var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showMenu && _vm.event != null)?_c('ul',{staticClass:"dropdown-menu",style:(_vm.position),on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();},"mouseup":function($event){$event.stopPropagation();$event.preventDefault();}}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }